module.exports = __webpack_public_path__ + "media/promo/hochland/images/bg_2-57358b3edd7f6582ac3b88828c332a04.png";